import Vuex from "vuex";
import diseases from "~/static/json/classified_icd10_20230201_with_en.json";
import { createClient } from "~/plugins/contentful.js";
const client = createClient();
import uuidv4 from "uuid/v4";
import api from "~/store/api.js";
import $ from "jquery";

export const state = {
  IS_LOGINED: "isLogined",
  ADD_RESULTS: "add_results",
  ADD_MASTER: "add_master",
  ADD_REQUEST_ID: "add_request_id",
  ADD_USER_INFO: "add_user_info",
  CHANGE_DISPLAY_INFO: "change_display_info",
  CHANGE_ACTIVE_SORT: "change_active_sort",
  CHECK_API: "check_api",
  SET_QUERY_FROM_HISTORY: "set_query_from_history",
  SET_NEWS_CATEGORIES: "set_news_categories",
  INITIALIZE_SEARCH_QUERY: "initialize_search_query",
  SET_ALL_BIOBANK_TO_SEACH_QUERY: "set_all_biobanks",
  TOGGLE_SWITCH_OPERATOR: "toggle_switch_operator",
  TOGGLE_SWITCH_LOGICAL_OPERATOR: "toggle_switch_logical_operator",
  ADD_INPUT_DATA: "add_input_data",
  REMOVE_DATA_FROM_INPUT_DATA: "remove_data_from_input_data",
  DELETE_SAMPLE_BOX: "delete_sample_box",
  COPY_SAMPLE_BOX: "copy_sample_box",
  TOGGLE_RESULT_SUMMARY: "toggle_result_summary",
  INITIALIZE_SAMPLE: "initialize_sample",
  SET_HISTORY: "set_history",
  TOGGLE_SAMPLE_LINE_WRAP: "toggle_sample_line_wrap"
};

const store = () =>
  new Vuex.Store({
    state: {
      isFailedAuthorization: (() => {
        if (
          window.location.hash === "#error" &&
          window.location.pathname === "/main/"
        ) {
          window.location.pathname = "/";
        } else {
          return window.location.hash === "#error";
        }
      })(), // AMED ログインからリダイレクトされて認証エラーが起きているか
      isLogined: false,
      results: {}, //パネルで作成している検索条件の結果を格納する配列
      master: {},
      diseases: diseases,
      offset: 0,
      request_id: "",
      user_info: {},
      active_sort: {
        item: "participant_id",
        order: "asc"
      },
      display_info: {
        //検索結果のテーブルカラムの表示、非表示
        graph: {
          sample_type: true,
          age_sampling: true,
          previous_disease_nm: true,
          disease: true,
          sex: true,
          data_type: true,
          vendor_platform: true
        },
        list: {
          save: true,
          lastupdate: true,
          biobank: true,
          participant_id: true,
          participant_collection: true,
          sex: true,
          previous_disease_cd: true,
          previous_disease_nm: true,
          prospective_collection: true,
          sample_id: true,
          disease_cd: true,
          disease_nm: true,
          sample_type: true,
          age_sampling: true,
          consent_information: true,
          analytical_data_id: true,
          data_type: true,
          vendor: true,
          platform: true
        }
      },
      api_check: false,
      query_from_history: {},
      biobank_mail: {
        TMM: "support@idb.megabank.tohoku.ac.jp",
        BBJ: "shiryo_h@biobankjp.net",
        OBB: "biobank@okayama-u.ac.jp",
        "6NC": "secretariat@ncbiobank.org",
        KUB: "biobankcs@kuhp.kyoto-u.ac.jp",
        THB: "bank298@hosp.tsukuba.ac.jp",
        TMD: "biobank@ml.tmd.ac.jp",
        KBR: "brcenter@med.kobe -u.ac.jp",
        BBS: "biobank_shinshu@shinshu-u.ac.jp"
      },
      biobank_information: [
        { name: "BBJ", link: "https://biobankjp.org/", logo: "BBJ.png" },
        {
          name: "TMM",
          link: "http://www.dist.megabank.tohoku.ac.jp/",
          logo: "TMM.svg"
        },
        { name: "6NC", link: "http://ncbiobank.org/", logo: "6NC.png" },
        {
          name: "KUB",
          link: "https://www.kyotocbrc.kuhp.kyoto-u.ac.jp/",
          logo: "KUB.png"
        },
        { name: "TMD", link: "http://www.tmd.ac.jp/brc/", logo: "TMD.svg" },
        {
          name: "THB",
          link:
            "http://www.hosp.tsukuba.ac.jp/outpatient/facility/biobank.html",
          logo: "THB.png"
        },
        {
          name: "OBB",
          link: "http://biobank.ccsv.okayama-u.ac.jp/",
          logo: "OBB.svg"
        },
        {
          name: "KBR",
          link: "https://www.hosp.kobe-u.ac.jp/brc/",
          logo: "KBR.png"
        },
        {
          name: "BBS",
          link: "https://wwwhp.md.shinshu-u.ac.jp/biobank/",
          logo: "BBS.svg"
        }
      ],
      news_categories: [],
      input_data: {
        biobank_list: [],
        collection: null,
        condition: {
          type: "and",
          conditions: []
        }
      },
      is_result_summary_on: false,
      history: [],
      sample_line_nowrap: false
    },
    getters: {
      isFailedAuthorization: state => state.isFailedAuthorization,
      isLogined: state => state.isLogined,
      fetch_results: state => state.results,
      fetch_master: state => state.master,
      fetch_disease: state => state.diseases,
      fetch_offset: state => state.offset,
      fetch_request_id: state => state.request_id,
      fetch_user_info: state => state.user_info,
      fetch_display_info: state => state.display_info,
      fecth_active_sort: state => state.active_sort,
      is_api_checked: state => state.api_check,
      fetch_query_from_history: state => state.query_from_history,
      fetch_biobank_mail: state => state.biobank_mail,
      fetch_biobank_information: state => state.biobank_information,
      fetch_news_categories: state => state.news_categories,
      fetch_input_data: state => state.input_data,
      fetch_toggle_result_summary: state => state.is_result_summary_on,
      fetch_history: state => state.history,
      fetch_sample_line_nowrap: state => state.sample_line_nowrap,
      selectable_collection_ids: state => {
        const allCollections =
          state.master?.master_participant_collection_list || [];

        const biobankCollectionMapping =
          state.master?.master_participant_collection_biobank_map_list || [];

        const checkedBiobankIds = state?.input_data.biobank_list || [];

        const reducedMapping = biobankCollectionMapping.reduce((acc, cur) => {
          if (acc[cur.biobank_id]) {
            acc[cur.biobank_id].push(cur.collection_id);
          } else {
            acc[cur.biobank_id] = [cur.collection_id];
          }
          return acc;
        }, {});

        const selectableCollections = allCollections.filter(collection => {
          return checkedBiobankIds.some(biobankId => {
            console.log("biobankId", biobankId);
            console.log("reducedMapping[biobankId]", reducedMapping[biobankId]);
            return reducedMapping[biobankId]?.includes(collection.id);
          });
        });

        console.log("selectableCollections", selectableCollections);

        return selectableCollections || [];
      },
      is_collection_search: state => {
        console.log("is_collection_search getter");
        return !!state.input_data.collection;
      },
      collection_biobank_mapping: state => {
        const biobankCollectionMapping =
          state.master?.master_participant_collection_biobank_map_list || [];
        const reducedMapping = biobankCollectionMapping.reduce((acc, cur) => {
          if (acc[cur.biobank_id]) {
            acc[cur.biobank_id].push(cur.collection_id);
          } else {
            acc[cur.biobank_id] = [cur.collection_id];
          }
          return acc;
        }, {});

        return reducedMapping;
      }
    },
    actions: {
      [state.IS_LOGINED]({ commit }, bool) {
        commit(state.IS_LOGINED, bool);
      },
      [state.ADD_RESULTS]({ commit }, result) {
        commit(state.ADD_RESULTS, result);
      },
      [state.ADD_MASTER]({ commit }, master) {
        commit(state.ADD_MASTER, master);
      },
      [state.ADD_REQUEST_ID]({ commit }, new_id) {
        commit(state.ADD_REQUEST_ID, new_id);
      },
      [state.ADD_USER_INFO]({ commit }, user_info) {
        commit(state.ADD_USER_INFO, user_info);
      },
      [state.CHANGE_DISPLAY_INFO]({ commit }, obj) {
        commit(state.CHANGE_DISPLAY_INFO, obj);
      },
      [state.CHANGE_ACTIVE_SORT]({ commit }, sort_obj) {
        commit(state.CHANGE_ACTIVE_SORT, sort_obj);
      },
      [state.CHECK_API]({ commit }) {
        commit(state.CHECK_API);
      },
      [state.SET_QUERY_FROM_HISTORY]({ commit }, past_query) {
        commit(state.SET_QUERY_FROM_HISTORY, past_query);
      },
      [state.SET_NEWS_CATEGORIES]({ commit }) {
        commit(state.SET_NEWS_CATEGORIES);
      },
      [state.INITIALIZE_SEARCH_QUERY]({ commit }) {
        commit(state.INITIALIZE_SEARCH_QUERY);
      },
      [state.TOGGLE_SWITCH_OPERATOR]({ commit }, data) {
        commit(state.TOGGLE_SWITCH_OPERATOR, data);
      },
      [state.TOGGLE_SWITCH_LOGICAL_OPERATOR]({ commit }, data) {
        commit(state.TOGGLE_SWITCH_LOGICAL_OPERATOR, data);
      },
      [state.ADD_INPUT_DATA]({ commit }, data) {
        commit(state.ADD_INPUT_DATA, data);
      },
      [state.REMOVE_DATA_FROM_INPUT_DATA]({ commit }, data) {
        commit(state.REMOVE_DATA_FROM_INPUT_DATA, data);
      },
      [state.DELETE_SAMPLE_BOX]({ commit }, panel_id_to_remove) {
        commit(state.DELETE_SAMPLE_BOX, panel_id_to_remove);
      },
      [state.COPY_SAMPLE_BOX]({ commit }, condition) {
        commit(state.COPY_SAMPLE_BOX, condition);
      },
      [state.TOGGLE_RESULT_SUMMARY]({ commit }) {
        commit(state.TOGGLE_RESULT_SUMMARY);
      },
      [state.INITIALIZE_SAMPLE]({ commit }) {
        commit(state.INITIALIZE_SAMPLE);
      },
      [state.SET_HISTORY]({ commit }, history) {
        commit(state.SET_HISTORY, history);
      },
      [state.TOGGLE_SAMPLE_LINE_WRAP]({ commit }) {
        commit(state.TOGGLE_SAMPLE_LINE_WRAP);
      }
    },
    mutations: {
      [state.IS_LOGINED](state, bool) {
        state.isLogined = bool;
      },
      [state.ADD_RESULTS](state, response) {
        if (response.type === "new") {
          state.results = response.data.search_result;
        } else if (response.type === "sort") {
          state.results.records = response.data.search_result.records;
        } else {
          state.results.records = state.results.records.concat(
            response.data.search_result.records
          );
        }
      },
      [state.ADD_MASTER](state, master) {
        state.master = master;
        state.master["master_disease_list"] = diseases;
        state.master.master_biobank_list.forEach(biobank => {
          state.input_data.biobank_list.push(biobank.biobank_id);
        });
      },
      [state.ADD_REQUEST_ID](state, new_id) {
        state.request_id = new_id;
      },
      [state.ADD_USER_INFO](state, user_info) {
        state.user_info = user_info;
      },
      [state.CHANGE_DISPLAY_INFO](state, obj) {
        state.display_info[obj.type][obj.option] = !state.display_info[
          obj.type
        ][obj.option];
      },
      [state.CHANGE_ACTIVE_SORT](state, sort_obj) {
        state.active_sort = sort_obj;
      },
      [state.CHECK_API](state) {
        state.api_check = true;
      },
      [state.SET_QUERY_FROM_HISTORY](state, query) {
        let past_query = $.extend(true, {}, query);
        delete past_query["end_timestamp"];
        delete past_query["start_timestamp"];
        delete past_query["status"];
        state.request_id = past_query["request_id"];
        past_query.condition.conditions.forEach(condition => {
          if (condition.type === "exists_all") {
            condition.panel_id = uuidv4();
          }
        });
        if (localStorage.getItem("search_mode") === "advanced") {
          past_query.condition.conditions.forEach(condition => {
            //病名検索モードの検索をアドバンスモード用のクエリに変換
            if (condition.conditions) {
              condition.conditions = condition.conditions.filter(
                disease_condition => {
                  if (
                    disease_condition.name &&
                    disease_condition.name.indexOf("disease") !== -1 &&
                    disease_condition.name.indexOf("previous") === -1
                  ) {
                    return false;
                  } else {
                    return true;
                  }
                }
              );
            }
          });
        }

        state.query_from_history = past_query;
        setTimeout(() => {
          if (localStorage.getItem("search_mode") === "simple") {
            let conditions_to_pass = {};
            past_query.condition.conditions.forEach(condition => {
              if (condition.grouping === "biological_sample_info") {
                condition.conditions.forEach(sample_condition => {
                  if (sample_condition.conditions) {
                    sample_condition.conditions.forEach(
                      sample_disease_condition => {
                        if (
                          (sample_disease_condition.type === "not" &&
                            sample_disease_condition.condition.conditions[0].name.indexOf(
                              "disease"
                            ) !== -1) ||
                          (sample_disease_condition.name &&
                            sample_disease_condition.name.indexOf("disease") !==
                              -1)
                        ) {
                          conditions_to_pass = sample_condition;
                        }
                      }
                    );
                  }
                });
              } else if (condition.conditions) {
                condition.conditions.forEach(disease_condition => {
                  if (
                    disease_condition.name &&
                    disease_condition.name.indexOf("disease") !== -1 &&
                    disease_condition.name.indexOf("previous") === -1
                  ) {
                    conditions_to_pass = condition;
                  }
                });
              }
            });
            //notは削除
            conditions_to_pass.conditions = conditions_to_pass.conditions.map(
              disease_condition => {
                if (disease_condition.type === "not") {
                  return disease_condition.condition.conditions[0];
                } else {
                  return disease_condition;
                }
              }
            );
            let past_query_condition = {
              type: "and",
              conditions: [conditions_to_pass]
            };
          }
          state.input_data.condition = past_query.condition;
          state.input_data.biobank_list = state.query_from_history.biobank_list.concat();
        }, 700);
      },
      [state.SET_NEWS_CATEGORIES](state) {
        client
          .getEntries({
            // fetch all blog posts sorted by creation date
            content_type: "category"
          })
          .then(entries => {
            state.news_categories = entries.items;
          })
          .catch(console.error);
      },
      [state.INITIALIZE_SEARCH_QUERY](state) {
        state.input_data = {
          biobank_list: [],
          condition: {
            type: "and",
            conditions: []
          }
        };
      },
      [state.TOGGLE_SWITCH_OPERATOR](state, data) {
        let conditions = state.input_data.condition.conditions;
        if (data.type === "previous_disease" || data.panel_id === "simple") {
          let is_previous_disease = false;
          conditions.forEach(condition => {
            if (
              condition.conditions !== undefined &&
              condition.grouping !== "biological_sample_info"
            ) {
              is_previous_disease = false;
              condition.conditions.forEach(previous_disease_condition => {
                if (
                  previous_disease_condition.name !== undefined &&
                  previous_disease_condition.name.indexOf("disease") !== -1
                ) {
                  is_previous_disease = true;
                }
                if (previous_disease_condition.conditions !== undefined) {
                  previous_disease_condition.conditions.forEach(
                    previous_disease_condition_datam => {
                      if (
                        previous_disease_condition_datam.type === "not" &&
                        previous_disease_condition_datam.condition.conditions[0].name.indexOf(
                          data.type
                        ) !== -1
                      ) {
                        is_previous_disease = true;
                      } else if (
                        previous_disease_condition_datam.type ===
                          "exists_all" &&
                        previous_disease_condition_datam.condition.conditions[0].name.indexOf(
                          data.type
                        ) !== -1
                      ) {
                        is_previous_disease = true;
                      } else if (
                        previous_disease_condition_datam.name &&
                        previous_disease_condition_datam.name.indexOf(
                          data.type
                        ) !== -1
                      ) {
                        is_previous_disease = true;
                      }
                    }
                  );
                }
              });
              if (is_previous_disease) {
                if (data.logical_operator === "and") {
                  condition.type = "exists_all";
                  condition.grouping = "participant_info";
                } else if (data.logical_operator === "or") {
                  condition.type = "or";
                  delete condition.grouping;
                }
              }
            }
          });
        } else if (
          data.type === "sample_type" ||
          data.type === "disease" ||
          data.type === "data_type" ||
          data.type === "vendor" ||
          data.type === "platform"
        ) {
          let sample_already_exist = false;
          conditions.forEach(item => {
            if (item.type === "exists_all") {
              sample_already_exist = true;
            }
          });
          if (sample_already_exist) {
            conditions.forEach(condition => {
              if (
                condition.type === "exists_all" &&
                condition.panel_id === data.panel_id
              ) {
                condition.conditions.forEach(sample_condition => {
                  if (sample_condition.conditions !== undefined) {
                    let is_target_condition = false;
                    sample_condition.conditions.forEach(
                      sample_condition_datam => {
                        if (
                          sample_condition_datam.type === "not" &&
                          sample_condition_datam.condition.conditions[0].name.indexOf(
                            data.type
                          ) !== -1
                        ) {
                          is_target_condition = true;
                        } else if (
                          sample_condition_datam.name &&
                          sample_condition_datam.name.indexOf(data.type) !== -1
                        ) {
                          is_target_condition = true;
                        }
                      }
                    );
                    if (is_target_condition) {
                      if (data.logical_operator === "and") {
                        sample_condition.type = "exists_all";
                        sample_condition.grouping = "participant_info";
                      } else if (data.logical_operator === "or") {
                        sample_condition.type = "or";
                        delete sample_condition.grouping;
                      }
                    }
                  }
                });
              }
            });
          } else {
            return;
          }
        }
      },
      [state.TOGGLE_SWITCH_LOGICAL_OPERATOR](state, data) {
        let conditions = state.input_data.condition.conditions.concat();
        let is_in_sample = false;
        if (
          data.type === "disease" ||
          data.type === "sample_type" ||
          data.type === "data_type" ||
          data.type === "vendor" ||
          data.type === "platform"
        ) {
          is_in_sample = true;
          let target_conditions = [];
          conditions.forEach(condition => {
            if (
              condition.grouping === "biological_sample_info" &&
              condition.panel_id === data.panel_id
            ) {
              target_conditions = condition.conditions;
            }
          });
          conditions = target_conditions.concat();
        }
        if (data.type === "disease" || data.type === "previous_disease") {
          if (data.val.cd !== "") {
            data.type += "_cd";
            data.val = data.val.cd;
          } else {
            data.type += "_nm";
            data.val = data.val.nm.ja;
          }
        }
        conditions = conditions.map(condition => {
          if (
            (data.type === "sample_type" && condition.name === "sample_type") ||
            (condition.type === "not" &&
              condition.condition.conditions[0].name === "sample_type")
          ) {
            let new_obj;
            if (!data.operator) {
              new_obj = {
                type: "not",
                condition: {
                  type: "exists_all",
                  grouping: "participant_info",
                  conditions: [$.extend(true, {}, condition)]
                }
              };
            } else {
              new_obj = $.extend(true, {}, condition.condition.conditions[0]);
            }
            condition = new_obj;
          } else if (
            condition.conditions !== undefined &&
            data.name !== "sample_type"
          ) {
            condition.conditions = condition.conditions.map(
              disease_condition => {
                if (
                  (!data.operator &&
                    disease_condition.name === data.type &&
                    disease_condition.value === data.val) ||
                  (!data.operator &&
                    disease_condition.type === "and" &&
                    disease_condition.conditions[0].name === data.type &&
                    disease_condition.conditions[0].value === data.val)
                ) {
                  //not equal
                  let new_obj = {
                    type: "not",
                    condition: {
                      type: "exists_all",
                      grouping: "participant_info",
                      conditions: [$.extend(true, {}, disease_condition)]
                    }
                  };
                  return new_obj;
                } else if (
                  data.operator &&
                  disease_condition.condition !== undefined
                ) {
                  // equal
                  let new_obj = {};
                  const fitst_disease_condition =
                    disease_condition.condition.conditions[0];
                  if (
                    (fitst_disease_condition.name === data.type &&
                      fitst_disease_condition.value === data.val) ||
                    (fitst_disease_condition.type === "and" &&
                      fitst_disease_condition?.conditions[0]?.name ===
                        data.type &&
                      fitst_disease_condition?.conditions[0]?.value ===
                        data.val)
                  ) {
                    new_obj = $.extend(true, {}, fitst_disease_condition);
                    return new_obj;
                  } else {
                    return disease_condition;
                  }
                } else {
                  return disease_condition;
                }
              }
            );
          }
          return condition;
        });
        if (is_in_sample) {
          state.input_data.condition.conditions = state.input_data.condition.conditions.map(
            condition => {
              if (
                condition.grouping === "biological_sample_info" &&
                condition.panel_id === data.panel_id
              ) {
                condition.conditions = conditions;
              }
              return condition;
            }
          );
        } else {
          state.input_data.condition.conditions = conditions;
        }
      },
      /**
       *
       * @param {*} state
       * @param {object} data
       *
       * @returns
       */
      [state.ADD_INPUT_DATA](state, data) {
        //val, type, num, operator, logical_operator
        let conditions = state.input_data.condition.conditions.concat();
        if (data.is_new_panel) {
          state.input_data.condition.conditions.push(data.obj);
        } else {
          let obj = {
            type: data.logical_operator,
            conditions: [
              {
                type: "item",
                operator: data.operator,
                name: data.type,
                value: data.val
              }
            ]
          };

          if (data.type === "biobank") {
            state.input_data.biobank_list = data.val;
          } else if (data.type === "collection_condition_toggle") {
            if (data.checked === true) {
              state.input_data.collection = {
                category: "participant",
                collection_id_list: [],
                type: "or"
              };
            } else {
              state.input_data.collection = null;
            }
          } else if (data.type === "collection_id_toggle") {
            if (data.checked) {
              state.input_data.collection.collection_id_list.push(data.val);
            } else {
              state.input_data.collection.collection_id_list = state.input_data.collection.collection_id_list.filter(
                item => item !== data.val
              );
            }
          } else if (data.type === "participant_id") {
            obj = {
              type: "item",
              operator: "eq",
              name: data.type,
              value: data.val
            };

            if (!data.val) {
              state.input_data.condition.conditions = conditions.filter(
                item => item.name !== data.type
              );
            } else {
              let already_exist = false;
              conditions = conditions.map(item => {
                if (item.name === data.type) {
                  already_exist = true;
                  item.value = data.val;
                }
                return item;
              });
              if (!already_exist) {
                state.input_data.condition.conditions.push(obj);
              }
            }
          } else if (data.type === "sex") {
            conditions = conditions.filter(item => {
              let flag = true;
              if (item.conditions !== undefined) {
                item.conditions.forEach(sex_obj => {
                  if (sex_obj.name === "sex") {
                    flag = false;
                  }
                });
              }
              return flag;
            });
            if (data.val.length !== 0) {
              let sex_obj = {
                type: "or",
                conditions: []
              };
              data.val.forEach(sex => {
                let obj = {
                  type: "item",
                  operator: "eq",
                  name: "sex",
                  value: sex
                };
                sex_obj.conditions.push(obj);
              });
              conditions.push(sex_obj);
            }
            state.input_data.condition.conditions = conditions;
            return;
          } else if (
            data.type === "previous_disease" ||
            data.panel_id === "simple"
          ) {
            if (data.val === undefined) return;
            if (data.val.cd !== "") {
              obj.conditions[0].name += "_cd";
              obj.conditions[0].value = data.val.cd;
            } else {
              obj.conditions[0].name += "_nm";
              obj.conditions[0].value = data.val.nm.ja;
            }
            /* 重複チェック */
            let is_unique = true;
            conditions.forEach(condition => {
              if (condition.conditions !== undefined) {
                condition.conditions.forEach(previous_disease_condition => {
                  if (!data.equal && previous_disease_condition.condition) {
                    previous_disease_condition.condition.conditions.forEach(
                      previous_disease_not_codition => {
                        if (
                          previous_disease_not_codition.name ===
                            obj.conditions[0].name &&
                          previous_disease_not_codition.value ===
                            obj.conditions[0].value
                        ) {
                          is_unique = false;
                        }
                      }
                    );
                  } else if (
                    previous_disease_condition.name ===
                      obj.conditions[0].name &&
                    previous_disease_condition.value === obj.conditions[0].value
                  ) {
                    is_unique = false;
                    return;
                  }
                });
              }
            });

            if (is_unique) {
              let previous_diseases_already_exist = false;
              conditions.forEach(condition => {
                if (
                  condition.conditions !== undefined &&
                  condition.type !== "exists_all"
                ) {
                  previous_diseases_already_exist = false;
                  condition.conditions.forEach(previous_disease_condition => {
                    if (
                      !previous_disease_condition.name &&
                      previous_disease_condition.type === "not"
                    ) {
                      previous_disease_condition.condition.conditions.forEach(
                        previous_disease_not_codition => {
                          if (
                            previous_disease_not_codition.name.indexOf(
                              data.type
                            ) !== -1
                          ) {
                            previous_diseases_already_exist = true;
                          }
                        }
                      );
                    } else if (
                      previous_disease_condition.name.indexOf(data.type) !== -1
                    ) {
                      previous_diseases_already_exist = true;
                    }
                  });
                  if (previous_diseases_already_exist) {
                    condition.conditions.push(obj.conditions[0]);
                  }
                }
              });
              if (!previous_diseases_already_exist) {
                conditions.push(obj);
              }
            }
            state.input_data.condition.conditions = conditions;
          } else if (
            data.type === "disease" ||
            data.type === "sample_type" ||
            data.type === "sample_quality_item" ||
            data.type === "agreement_item" ||
            data.type === "data_type" ||
            data.type === "vendor" ||
            data.type === "platform"
          ) {
            const sample_already_exist = conditions.some(item => {
              return (
                item.type === "exists_all" && item.panel_id === data.panel_id
              );
            });
            if (!sample_already_exist) {
              let sample_obj = {
                type: "exists_all",
                grouping: "biological_sample_info",
                conditions: []
              };
              conditions.push(sample_obj);
            }

            if (
              data.type === "sample_type" ||
              data.type === "data_type" ||
              data.type === "vendor" ||
              data.type === "platform"
            ) {
              let this_sample_exist = false;
              conditions.forEach(condition => {
                if (
                  condition.type === "exists_all" &&
                  condition.panel_id === data.panel_id
                ) {
                  condition.conditions = condition.conditions.filter(
                    sample_condition => {
                      this_sample_exist = false;
                      if (sample_condition && sample_condition.conditions) {
                        sample_condition.conditions.forEach(
                          sample_condition_datam => {
                            if (
                              sample_condition_datam.type === "not" &&
                              sample_condition_datam.condition.conditions[0].name.indexOf(
                                data.type
                              ) !== -1
                            ) {
                              this_sample_exist = true;
                            } else if (
                              sample_condition_datam.name &&
                              sample_condition_datam.name === data.type
                            ) {
                              this_sample_exist = true;
                            }
                          }
                        );
                      } else if (
                        sample_condition.name === data.type ||
                        (sample_condition.type === "not" &&
                          sample_condition.condition.conditions[0].name ===
                            data.type)
                      ) {
                        this_sample_exist = true;
                      }
                      return !this_sample_exist;
                    }
                  );
                }
              });
              let input_obj = {};
              if (data.val[0] === "" && data.type === "sample_type") {
                conditions.forEach(sample_condition => {
                  if (
                    sample_condition.panel_id === data.panel_id &&
                    sample_condition.conditions !== undefined
                  ) {
                    let frag = true;
                    sample_condition.conditions = sample_condition.conditions.filter(
                      sample_quality_condition => {
                        frag = true;
                        if (
                          sample_quality_condition.conditions &&
                          sample_quality_condition.conditions[0].name.indexOf(
                            "sample_quality"
                          ) !== -1
                        ) {
                          frag = false;
                        }
                        return frag;
                      }
                    );
                  }
                });
                return;
              } else if (data.val[0] === "") {
                return;
              }
              if (data.type === "sample_type") {
                if (data.operator === "eq") {
                  input_obj = {
                    type: "item",
                    operator: "eq",
                    name: data.type,
                    value: data.val[0]
                  };
                } else if (data.operator === "not") {
                  input_obj = {
                    type: "not",
                    condition: {
                      type: "exists_all",
                      grouping: "participant_info",
                      conditions: [
                        {
                          type: "item",
                          operator: "eq",
                          name: data.type,
                          value: data.val[0]
                        }
                      ]
                    }
                  };
                }
              } else {
                obj.conditions = [];
                if (data.logical_operator === "or") {
                  obj.type = "or";
                  delete obj.grouping;
                } else if (data.logical_operator === "and") {
                  obj.type = "exists_all";
                  obj.grouping = "participant_info";
                }

                data.val.forEach(input_val => {
                  if (input_val.logical_operator) {
                    obj.conditions.push({
                      type: "item",
                      operator: "eq",
                      name: data.type,
                      value: input_val.value
                    });
                  } else {
                    obj.conditions.push({
                      type: "not",
                      condition: {
                        type: "exists_all",
                        grouping: "participant_info",
                        conditions: [
                          {
                            type: "item",
                            operator: "eq",
                            name: data.type,
                            value: input_val.value
                          }
                        ]
                      }
                    });
                  }
                });
                input_obj = obj;
              }

              if (data.val.length !== 0) {
                conditions.forEach(condition => {
                  if (
                    condition.type === "exists_all" &&
                    condition.panel_id === data.panel_id
                  ) {
                    condition.conditions.push(input_obj);
                  }
                });
              }
            } else if (data.type === "disease") {
              if (data.val === undefined) return;
              if (data.val.cd !== "") {
                obj.conditions[0].name += "_cd";
                obj.conditions[0].value = data.val.cd;
              } else {
                obj.conditions[0].name += "_nm";
                obj.conditions[0].value = data.val.nm.ja;
              }
              /* 重複チェック */
              let is_unique = true;
              conditions.forEach(condition => {
                if (
                  condition.type === "exists_all" &&
                  condition.panel_id === data.panel_id
                ) {
                  condition.conditions.forEach(sample_condition => {
                    if (sample_condition.conditions !== undefined) {
                      sample_condition.conditions.forEach(
                        sample_condition_datam => {
                          if (!data.equal && sample_condition_datam.condition) {
                            sample_condition_datam.condition.conditions.forEach(
                              sample_condition_not_datam => {
                                if (
                                  sample_condition_not_datam.name ===
                                    obj.conditions[0].name &&
                                  sample_condition_not_datam.value ===
                                    obj.conditions[0].value
                                ) {
                                  is_unique = false;
                                }
                              }
                            );
                          } else if (
                            sample_condition_datam.value ===
                              obj.conditions[0].value &&
                            sample_condition_datam.name ===
                              obj.conditions[0].name
                          ) {
                            is_unique = false;
                            return;
                          }
                        }
                      );
                    }
                  });
                }
              });
              if (is_unique) {
                let disease_already_exist = false;
                conditions.forEach(condition => {
                  if (
                    condition.type === "exists_all" &&
                    condition.panel_id === data.panel_id
                  ) {
                    condition.conditions.forEach(sample_condition => {
                      if (sample_condition.conditions !== undefined) {
                        disease_already_exist = false;
                        sample_condition.conditions.forEach(
                          sample_condition_datam => {
                            if (
                              !sample_condition_datam.name &&
                              sample_condition_datam.type === "not"
                            ) {
                              sample_condition_datam.condition.conditions.forEach(
                                previous_disease_not_codition => {
                                  if (
                                    previous_disease_not_codition?.name?.includes(
                                      data.type
                                    )
                                  ) {
                                    disease_already_exist = true;
                                  }
                                }
                              );
                            } else if (
                              sample_condition_datam.name ===
                                obj.conditions[0].name ||
                              (sample_condition_datam.type === "and" &&
                                sample_condition_datam.conditions[0].name ===
                                  obj.conditions[0].name)
                            ) {
                              disease_already_exist = true;
                            }
                          }
                        );
                        if (disease_already_exist) {
                          if (data.disease_specific) {
                            obj.type = "and";
                            obj.conditions.push(...data.disease_specific);
                            sample_condition.conditions.push(obj);
                          } else {
                            sample_condition.conditions.push(obj.conditions[0]);
                          }
                        }
                      }
                    });
                    if (!disease_already_exist) {
                      if (data.disease_specific) {
                        obj.type = "and";
                        obj.conditions.push(...data.disease_specific);
                        condition.conditions.push({
                          type: "or",
                          conditions: [obj]
                        });
                      } else {
                        condition.conditions.push(obj);
                      }
                    }
                  }
                });
              }
            } else if (
              data.type === "agreement_item" ||
              data.type === "sample_quality_item"
            ) {
              conditions = conditions.map(condition => {
                if (
                  condition.type === "exists_all" &&
                  condition.panel_id === data.panel_id
                ) {
                  let is_agreement = false;
                  condition.conditions = condition.conditions.filter(
                    sample_condition => {
                      is_agreement = false;
                      if (sample_condition.conditions !== undefined) {
                        sample_condition.conditions.forEach(
                          sample_quality_condition => {
                            if (
                              sample_quality_condition.name &&
                              sample_quality_condition.name === data.type
                            ) {
                              is_agreement = true;
                            }
                          }
                        );
                      }
                      return !is_agreement;
                    }
                  );
                  let is_all_val_empty = true;
                  data.val = data.val.filter(agreement_condition => {
                    let is_val_empty = false;
                    agreement_condition.conditions.forEach(agreement => {
                      if (
                        agreement.name ===
                          `${data.type.replace("_item", "")}_value_string` &&
                        agreement.value !== ""
                      ) {
                        is_all_val_empty = false;
                      }
                      if (agreement.value === "") {
                        is_val_empty = true;
                      }
                    });
                    return !is_val_empty;
                  });
                  if (!is_all_val_empty) {
                    condition.conditions = condition.conditions.concat(
                      data.val
                    );
                  }
                }
                return condition;
              });
            }
            state.input_data.condition.conditions.forEach(condition => {
              if (condition.panel_id === data.panel_id) {
                state.input_data.condition.conditions = conditions;
              }
            });
          } else if (
            data.type === "age_sampling" ||
            data.type === "prospective_collection"
          ) {
            conditions.forEach(condition => {
              if (
                condition.type === "exists_all" &&
                condition.panel_id === data.panel_id
              ) {
                condition.conditions = condition.conditions.filter(
                  sample_condition => {
                    return sample_condition.name !== data.type;
                  }
                );
                condition.conditions = condition.conditions.concat(data.val);
              }
            });
            state.input_data.condition.conditions.forEach(condition => {
              if (condition.panel_id === data.panel_id) {
                state.input_data.condition.conditions = conditions;
              }
            });
          } else if (data.type === "prospective_collection") {
            let foundCondition = conditions.find(
              cond =>
                cond.type === "exists_all" && cond.panel_id === data.panel_id
            );
            foundCondition.conditions = foundCondition.conditions.filter(
              c => c.name !== "prospective_collection"
            );
            foundCondition.conditions.push({
              name: data.type,
              type: "item",
              value: data.val,
              operator: data.operator
            });

            state.input_data.condition.conditions.forEach(condition => {
              if (condition.panel_id === data.panel_id) {
                state.input_data.condition.conditions = conditions;
              }
            });
          }
        }
      },
      [state.REMOVE_DATA_FROM_INPUT_DATA](state, data) {
        if (
          data.type.includes("previous_disease") ||
          data.panel_id === "simple"
        ) {
          let conditions = state.input_data.condition.conditions.concat();
          if (data.removeData !== "all") {
            conditions = conditions.filter(condition => {
              if (
                condition.grouping !== "biological_sample_info" &&
                condition.conditions !== undefined
              ) {
                condition.conditions = condition.conditions.filter(obj => {
                  let flag = true;
                  if (
                    (obj.type === "not" || obj.type === "exists_all") &&
                    obj.condition.conditions[0].name.indexOf("disease") !== -1
                  ) {
                    if (data.type.indexOf("_cd") !== -1) {
                      flag =
                        obj.condition.conditions[0].value !==
                        data.removeData.cd;
                    } else if (data.type.indexOf("_nm") !== -1) {
                      flag =
                        obj.condition.conditions[0].value !==
                        data.removeData.nm.ja;
                    }
                  } else if (obj.name && obj.name.indexOf("disease") !== -1) {
                    if (data.type.indexOf("_cd") !== -1) {
                      flag = obj.value !== data.removeData.cd;
                    } else if (data.type.indexOf("_nm") !== -1) {
                      flag = obj.value !== data.removeData.nm.ja;
                    }
                  }
                  return flag;
                });
              }
              if (
                condition.conditions !== undefined &&
                condition.conditions.length === 0
              ) {
                return false;
              } else {
                return true;
              }
            });
          } else {
            conditions = conditions.filter(condition => {
              let flag = true;
              if (condition.grouping !== "biological_sample_info") {
                condition.conditions.forEach(obj => {
                  if (
                    (obj.type === "not" || obj.type === "exists_all") &&
                    obj.condition.conditions[0].name.indexOf("disease") !== -1
                  ) {
                    flag = false;
                  } else if (obj.name && obj.name.indexOf("disease") !== -1) {
                    flag = false;
                  }
                });
              }
              return flag;
            });
          }
          state.input_data.condition.conditions = conditions;
        } else if (data.type.includes("disease")) {
          let conditions = state.input_data.condition.conditions.concat();
          if (data.removeData !== "all") {
            conditions.forEach(condition => {
              if (
                condition.type === "exists_all" &&
                condition.panel_id === data.panel_id
              ) {
                condition.conditions = condition.conditions.filter(obj => {
                  let is_no_data = false;
                  if (obj.conditions !== undefined) {
                    obj.conditions = obj.conditions.filter(
                      disease_condition => {
                        let notEqual = (conditions, removeData, type) => {
                          let match_disease_specific = true;
                          if (removeData.disease_specific) {
                            let disease_specific_conditions = conditions.filter(
                              condition =>
                                condition.name.includes("disease_specific") &&
                                !condition.name.includes(
                                  "disease_specific_rank1"
                                )
                            );
                            match_disease_specific = Object.entries(
                              removeData.disease_specific
                            ).every(([key, value]) => {
                              return (
                                disease_specific_conditions.length ===
                                  Object.keys(removeData.disease_specific)
                                    .length &&
                                disease_specific_conditions.some(
                                  condition =>
                                    condition.name === key &&
                                    condition.value === value
                                )
                              );
                            });
                            return (
                              conditions[0].value !== removeData[type] &&
                              !match_disease_specific
                            );
                          } else {
                            const condition_has_disease_specific =
                              conditions[1] &&
                              conditions[1].name.includes("disease_specific");
                            if (condition_has_disease_specific) {
                              return true;
                            } else {
                              return conditions[0].value !== removeData[type];
                            }
                          }
                        };

                        let flag = true;
                        if (
                          disease_condition.type === "not" &&
                          disease_condition.condition.conditions[0]?.name?.includes(
                            "disease"
                          )
                        ) {
                          if (data.type.includes("_cd")) {
                            flag = notEqual(
                              disease_condition.condition.conditions,
                              data.removeData,
                              "cd"
                            );
                          } else if (data.type.includes("_nm")) {
                            flag = notEqual(
                              disease_condition.condition.conditions,
                              data.removeData.nm,
                              "ja"
                            );
                          }
                        } else if (
                          disease_condition.type === "not" &&
                          disease_condition.condition.conditions[0]?.conditions[0]?.name?.includes(
                            "disease"
                          )
                        ) {
                          if (data.type.includes("_cd")) {
                            flag = notEqual(
                              disease_condition.condition.conditions[0]
                                ?.conditions,
                              data.removeData,
                              "cd"
                            );
                          }
                        } else if (
                          disease_condition.type === "and" &&
                          disease_condition.conditions[0].name
                        ) {
                          if (data.type.includes("_cd")) {
                            flag = notEqual(
                              disease_condition.conditions,
                              data.removeData,
                              "cd"
                            );
                          } else if (data.type.includes("_nm")) {
                            flag = notEqual(
                              disease_condition.conditions,
                              data.removeData.nm,
                              "ja"
                            );
                          }
                        } else if (
                          disease_condition.name &&
                          disease_condition.name.includes("disease")
                        ) {
                          if (data.type.includes("_cd")) {
                            flag =
                              disease_condition.value !== data.removeData.cd;
                          } else if (data.type.includes("_nm")) {
                            flag =
                              disease_condition.value !== data.removeData.nm.ja;
                          }
                        }
                        return flag;
                      }
                    );
                    if (obj.conditions.length === 0) {
                      is_no_data = true;
                    }
                  }
                  return !is_no_data;
                });
              }
            });
          } else {
            conditions = conditions.map(condition => {
              if (
                condition.type === "exists_all" &&
                condition.panel_id === data.panel_id
              ) {
                condition.conditions = condition.conditions.filter(obj => {
                  let flag = true;
                  if (obj.conditions) {
                    obj.conditions.forEach(disease_condition => {
                      if (
                        disease_condition.type === "not" &&
                        disease_condition.condition.conditions[0].name.indexOf(
                          "disease"
                        ) !== -1
                      ) {
                        flag = false;
                      } else if (
                        disease_condition.name &&
                        disease_condition.name.indexOf("disease") !== -1
                      ) {
                        flag = false;
                      }
                    });
                  }
                  return flag;
                });
              }
              return condition;
            });
          }
          state.input_data.condition.conditions = conditions;
        } else if (
          data.type === "age_sampling" ||
          data.type === "prospective_collection"
        ) {
          let conditions = state.input_data.condition.conditions.concat();
          conditions.forEach(condition => {
            if (
              condition.type === "exists_all" &&
              condition.panel_id === data.panel_id
            ) {
              condition.conditions = condition.conditions.filter(
                sample_condition => {
                  return sample_condition.name !== data.type;
                }
              );
            }
          });
        } else {
          let newList = [];
          state.input_data.condition.conditions = state.input_data.condition.conditions.map(
            obj => {
              if (obj.name === data.type) {
                newList = obj.condition_list.filter(list => {
                  let val = list.value.replace(/ |\(/g, "_").replace(/\)/g, "");
                  return val !== data.removeData;
                });
                obj.condition_list = newList;
              }
            }
          );
        }
      },
      [state.DELETE_SAMPLE_BOX](state, panel_id_to_remove) {
        state.input_data.condition.conditions = state.input_data.condition.conditions.filter(
          condition => {
            return condition.panel_id !== panel_id_to_remove;
          }
        );
      },
      [state.COPY_SAMPLE_BOX](state, condition) {
        state.input_data.condition.conditions.push(condition);
      },
      [state.TOGGLE_RESULT_SUMMARY](state) {
        state.is_result_summary_on = !state.is_result_summary_on;
      },
      [state.INITIALIZE_SAMPLE](state) {
        state.input_data.condition.conditions = [];
      },
      [state.SET_HISTORY](state, history) {
        history.forEach(history_query => {
          let sample_condition_to_add = [];
          if (!history_query.condition.conditions) {
            history_query.condition.conditions = []
          }
          history_query.condition.conditions = history_query.condition.conditions.filter(
            condition => {
              let frag = true;
              if (condition.grouping === "participant_info") {
                condition.conditions.forEach(sample_condition => {
                  if (
                    sample_condition.type === "item" &&
                    sample_condition.name.includes("disease")
                  ) {
                    frag = true;
                  } else if (
                    sample_condition.type === "and" &&
                    sample_condition.conditions
                  ) {
                    //sample_condition.conditionsの同意情報、品質管理情報以外の項目をラップする
                    let sample_condition_filtered = [];
                    let agreement_or_quality_condition = [];
                    sample_condition.conditions.forEach(
                      sample_condition_datam => {
                        if (
                          sample_condition_datam?.name?.includes(
                            "sample_quality"
                          ) ||
                          sample_condition_datam?.name?.includes("agreement")
                        ) {
                          agreement_or_quality_condition.push(
                            sample_condition_datam
                          );
                        } else {
                          sample_condition_filtered.push(
                            sample_condition_datam
                          );
                        }
                      }
                    );
                    if (agreement_or_quality_condition.length > 0) {
                      sample_condition_filtered = sample_condition_filtered.concat(
                        {
                          type: "and",
                          conditions: agreement_or_quality_condition
                        }
                      );
                    }
                    sample_condition_to_add.push({
                      type: "exists_all",
                      grouping: "biological_sample_info",
                      conditions: sample_condition_filtered
                    });
                    frag = false;
                  } else {
                    condition.grouping = "biological_sample_info";
                  }
                });
              } else {
                frag = true;
              }
              return frag;
            }
          );
          if (sample_condition_to_add.length !== 0) {
            history_query.condition.conditions = history_query.condition.conditions.concat(
              sample_condition_to_add
            );
          }
          return history_query;
        });
        state.history = history;
      },
      [state.TOGGLE_SAMPLE_LINE_WRAP](state) {
        state.sample_line_nowrap = !state.sample_line_nowrap;
      }
    }
  });

export default store;
